import { render, staticRenderFns } from "./AtendimentoUnidades.vue?vue&type=template&id=0499abce&scoped=true"
import script from "./AtendimentoUnidades.vue?vue&type=script&lang=js"
export * from "./AtendimentoUnidades.vue?vue&type=script&lang=js"
import style0 from "./AtendimentoUnidades.vue?vue&type=style&index=0&id=0499abce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0499abce",
  null
  
)

export default component.exports